import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, useMemo, useState, useCallback } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import DaEditorWrapper from './LoadableDaEditorWrapper';
import { EditorFlavourConfigs } from '../DaEditorWrapper/config';
import mergeTheme from '../DaEditorWrapper/Themes/mergeTheme';
import CommentFallbackEditor from './CommentFallbackEditor';
import { CommentEditorSource } from './redux/types';
import { CommentEditorContext, EditorContext } from './context';
import commentTextTheme from '../DaEditorWrapper/Themes/Viewer/comments.scss';
import commentEditorTheme from '../DaEditorWrapper/Themes/Editor/comments.scss';
import s from './CommentEditor.scss';
const editorTheme = mergeTheme(commentTextTheme, commentEditorTheme);
/**
 * The standard version of our Comment editor.
 *
 * It wraps our DaEditor, passes on the necessary context values, sets up desired styles,
 * and includes a fallback editor.
 *
 * Be sure to wrap this in a `<CommentEditorProviders />`
 */ const CommentEditor = (_param)=>{
    var { className, loadingIndicator } = _param, rest = _object_without_properties(_param, [
        "className",
        "loadingIndicator"
    ]);
    const { t } = useTranslation();
    const { editorId, editorSource, shouldUseFallback, expandEditor, initialContent } = useContext(CommentEditorContext);
    const { props: editorProps } = useContext(EditorContext);
    const [fallbackInitialContent, setFallbackInitialContent] = useState(undefined);
    // We don't want the editor to rerender with each keypress
    const Fallback = useMemo(()=>/*#__PURE__*/ React.createElement(CommentFallbackEditor, {
            className: className,
            initialContent: fallbackInitialContent || initialContent,
            onChange: (editorState)=>{
                setFallbackInitialContent(editorState.rawContentState);
            }
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        shouldUseFallback,
        editorProps
    ]);
    // Hook into the focus event to expand the editor when the user clicks on it
    const { onFocus } = editorProps;
    const handleFocus = useCallback((ev)=>{
        expandEditor();
        onFocus && onFocus(ev);
    }, [
        expandEditor,
        onFocus
    ]);
    return shouldUseFallback ? Fallback : /*#__PURE__*/ React.createElement(DaEditorWrapper, _object_spread_props(_object_spread({
        loadingComponent: ()=>loadingIndicator,
        flavour: EditorFlavourConfigs.COMMENT,
        editorKey: editorId,
        theme: editorTheme,
        placeholder: editorSource === CommentEditorSource.Reply ? t('commentbox.editor.placeholder.reply') : t('commentbox.editor.placeholder'),
        tabIndex: 0,
        filterPaste: true,
        className: c(s['commentbox-editor'], className),
        initialContent: fallbackInitialContent || initialContent
    }, rest, editorProps), {
        onFocus: handleFocus
    }));
};
CommentEditor.displayName = 'CommentEditor';
export default CommentEditor;

//# sourceMappingURL=CommentEditor.js.map